import { Drawer } from '@mui/material';
import { ProjectSummaryContent, ProjectSummaryContentProps } from './project-summary-content.component';
import { useProjectSummaryDrawerStyles } from './project-summary-drawer.styles';

export interface ProjectSummaryDrawerProps extends ProjectSummaryContentProps {
  isOpen: boolean;
  onToggle: (open: boolean) => void;
}

export function ProjectSummaryDrawer(props: ProjectSummaryDrawerProps) {
  const classes = useProjectSummaryDrawerStyles();
  return (
    <Drawer
      disableEnforceFocus
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      open={props.isOpen}
      onClose={() => props.onToggle(false)}
    >
      <ProjectSummaryContent data={props.data} isLoading={props.isLoading} errorMessage={props.errorMessage} />
    </Drawer>
  );
}
